import * as yup from 'yup';
import i18n from 'i18next';
export const questionFormSchema = yup.object({
    name: yup.string().required('app_sylius.not_blank').max(254, 'max_length'),
    surname: yup.string().required('app_sylius.not_blank').max(254, 'max_length'),
    email: yup.string().required('app_sylius.not_blank').email('invalid_email').max(254, 'max_length').required(),
    phone: yup
        .string()
        .notRequired()
        .transform((curr, orig) => (orig === '' ? null : curr))
        .max(8, params => i18n.t('invalid_phone_number_max_length').replace('{{ limit }}', String(params.max)))
        .min(8, params => i18n.t('invalid_phone_number_min_length').replace('{{ limit }}', String(params.min))),
    messageSubject: yup.string().required('app_sylius.not_blank'),
    message: yup.string().required('app_sylius.not_blank'),
});
